import { Box } from "@chakra-ui/layout";
import { Link } from "@components/ui-kit";
import React, { type FC } from "react";
import type { ColumnProps } from ".";

export const Project: FC<React.PropsWithChildren<ColumnProps>> = ({ row }) => {
  return (
    <Box>
      {row.projects.map((p) => (
        <React.Fragment key={p.id}>
          <span title={`${p.code} – ${p.title.replace(" ", "-")}`}>
            <Link href={{ pathname: "/projects/detail", query: { id: p.id } }}>
              <div>{p.code}</div>
              <div>{p.title}</div>
            </Link>
          </span>
          <br />
        </React.Fragment>
      ))}
    </Box>
  );
};
